module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mode",
    on: {
      "click": function($event) {
        _vm.changeMode()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont",
    style: ({
      fontSize: _vm.size + 'px'
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.setCurrentMode === 0 ? '&#xe65f;' : _vm.setCurrentMode === 1 ? '&#xe628;' : '&#xe78a;')
    }
  }), _vm._v(" "), (_vm.title) ? _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.setCurrentMode === 0 ? '列表循环' : _vm.setCurrentMode === 1 ? '随机播放' : '单曲循环'))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2a7c352e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/mode/mode.vue
// module id = 196
// module chunks = 1